<template>
  <svg
    width="149px"
    height="18px"
    viewBox="0 0 149 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Bose</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home"
        transform="translate(-40.000000, -101.000000)"
        fill="#000000"
        fill-rule="nonzero"
      >
        <g id="Nav" transform="translate(40.000000, 98.000000)">
          <g id="Bose" transform="translate(0.000000, 3.000000)">
            <path
              d="M86.6718367,0.09 C85.1784744,0.101096298 83.8014227,0.898153096 83.0479592,2.18755102 C82.3591837,3.38326531 80.4177551,6.76469388 79.7179592,7.9622449 C79.4075106,8.47973863 79.4015561,9.12474992 79.702398,9.64788684 C80.0032398,10.1710238 80.5637248,10.4902911 81.1671429,10.4822449 L92.7238776,10.4822449 C92.7238776,10.4822449 90.9808163,13.4981633 90.6502041,14.0730612 C90.3575171,14.611629 89.793777,14.9470543 89.1808163,14.9473469 L87.3844898,14.9473469 C87.1380254,14.9441762 86.9105029,14.8145133 86.7821546,14.6040817 C86.6538063,14.3936501 86.6426625,14.1320115 86.7526531,13.9114286 C86.9693878,13.5202041 87.445102,12.7157143 87.445102,12.7157143 L76.9591837,12.7157143 L75.4402041,15.3459184 C75.1288932,15.8659692 75.1196048,16.5128315 75.4158553,17.0416064 C75.7121058,17.5703813 76.268616,17.9002503 76.8746939,17.9063265 L96.4579592,17.9063265 C97.9829538,17.9037793 99.3896979,17.0844052 100.144286,15.7591837 C100.89,14.4606122 102.642245,11.4042857 103.39898,10.1057143 C104.155714,8.80714286 103.198776,7.5177551 101.993878,7.5177551 L90.4408163,7.5177551 L92.5714286,3.82040816 C92.8830733,3.33568117 93.4204716,3.04343623 93.9967347,3.04530612 L95.7985714,3.04530612 C96.0345186,3.04617366 96.2544888,3.16466481 96.385029,3.36121267 C96.5155693,3.55776052 96.5394795,3.8064679 96.4487755,4.02428571 C96.265102,4.36040816 95.7140816,5.28061224 95.7140816,5.28061224 L106.183469,5.28061224 C106.183469,5.28061224 107.175306,3.57061224 107.755714,2.56408163 C108.031398,2.04489647 108.01645,1.4195408 107.716275,0.914120494 C107.4161,0.408700188 106.874131,0.0963483339 106.286327,0.09 L86.6718367,0.09 Z M78.3863265,0.0899435463 L58.8287755,0.0899435463 C57.3324103,0.0974006811 55.9482901,0.88484533 55.1773469,2.16734694 C54.415102,3.48061224 48.2106122,14.2328571 47.5365306,15.3918367 C46.862449,16.5508163 47.7881633,17.8989796 48.9930612,17.8989796 L68.5855102,17.8989796 C70.0835833,17.8944283 71.4695263,17.1045523 72.2369388,15.8179592 C72.9257143,14.6277551 79.2165306,3.7322449 79.8685714,2.59346939 C80.1610928,2.0702963 80.1531819,1.43100391 79.8478041,0.915229503 C79.5424263,0.399455099 78.9857052,0.0851001934 78.3863265,0.0899435463 L78.3863265,0.0899435463 Z M68.5322449,4.09959184 C68.2493878,4.58265306 63.0477551,13.5973469 62.7593878,14.1042857 C62.4572102,14.6231897 61.9033235,14.9437874 61.3028571,14.9473469 L59.4844898,14.9473469 C59.238797,14.9447051 59.0118909,14.8153633 58.8844329,14.6053005 C58.7569749,14.3952377 58.7470412,14.1342454 58.8581633,13.915102 L64.6530612,3.86632653 C64.9590401,3.35868926 65.5076907,3.04746236 66.1004082,3.04526193 L67.9242857,3.04526193 C68.1765588,3.04247344 68.4107241,3.17600259 68.5367547,3.39455703 C68.6627852,3.61311147 68.661061,3.88266753 68.5322449,4.09959184 Z M50.5304082,0.09 L28.4344898,0.09 L19.855102,14.9491837 L0,14.9491837 L0,17.9100196 L40.7020408,17.9100196 C42.217405,17.9146002 43.6191493,17.1071955 44.3755102,15.7940816 C45.1561224,14.4459184 46.3812245,12.3042857 46.9065306,11.3859184 C47.4318367,10.467551 46.8771429,9.29755102 45.9,8.99816327 C47.3741115,8.96775423 48.7299422,8.18447777 49.4926531,6.92265306 C50.2034694,5.70122449 51.3293878,3.7322449 51.9740816,2.61367347 C52.275886,2.0954955 52.278377,1.4556822 51.9806167,0.935169894 C51.6828564,0.414657588 51.1300648,0.0924950677 50.5304082,0.09 L50.5304082,0.09 Z M38.7973469,11.5310204 C38.5365306,11.9920408 37.6512245,13.5165306 37.3022449,14.1208163 C37.0079142,14.6375768 36.456924,14.9545367 35.8622449,14.9491837 L30.3171429,14.9491837 L32.8977551,10.4822449 L38.187551,10.4822449 C38.4374743,10.4822449 38.6685417,10.6151475 38.7941649,10.8312042 C38.919788,11.0472608 38.9210001,11.3138303 38.7973469,11.5310204 L38.7973469,11.5310204 Z M43.0842857,4.09591837 C42.8216327,4.55693878 41.9363265,6.08326531 41.5891837,6.68571429 C41.2948204,7.20334004 40.7427838,7.52049739 40.1473469,7.51408163 L34.6040816,7.51408163 L37.1755102,3.04714286 L42.4653061,3.04714286 C42.7168669,3.04381654 42.950954,3.17543174 43.0788265,3.392094 C43.206699,3.60875626 43.2087819,3.87729861 43.0842857,4.09591837 L43.0842857,4.09591837 Z M112.12898,0.09 L101.845102,17.9063265 L126.773265,17.9063265 L128.481429,14.9491837 L114.015306,14.9491837 L116.594082,10.4822449 L131.060204,10.4822449 L132.772041,7.5177551 L118.304082,7.5177551 L120.886531,3.04346939 L148.03898,3.04530612 L148.03898,0.09 L112.12898,0.09 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "logo-bose",
};
</script>

<style scoped lang="scss">
path {
  transition: fill 0.3s ease;
}
.theme-dark svg {
  path {
    fill: #ffffff;
  }
  &:hover {
    path {
      fill: #666;
    }
  }
}

.theme-light svg {
  path {
    fill: #000000;
  }
  &:hover {
    path {
      fill: #666;
    }
  }
}
</style>
